// Stockage unifié : utilise le module Data de CrazyGames (synchro cross-device)
// quand le jeu tourne sur CrazyGames, sinon localStorage. Écrit toujours dans
// localStorage en miroir pour rester fonctionnel partout.
import { isCrazyGames } from "./crazygames";

const cgData = () =>
  (isCrazyGames() && typeof window !== "undefined" && window.CrazyGames?.SDK?.data) || null;

export const store = {
  get(key) {
    const d = cgData();
    if (d) {
      try {
        const v = d.getItem(key);
        if (v !== null && v !== undefined) return v;
      } catch (e) {
        /* ignore */
      }
    }
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  },
  set(key, val) {
    try {
      localStorage.setItem(key, val);
    } catch (e) {
      /* ignore */
    }
    const d = cgData();
    if (d) {
      try {
        d.setItem(key, String(val));
      } catch (e) {
        /* ignore */
      }
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      /* ignore */
    }
    const d = cgData();
    if (d) {
      try {
        d.removeItem(key);
      } catch (e) {
        /* ignore */
      }
    }
  },
};
